<template>
  <div class="export-report">
    <div v-if="!loadingReport">
      <vs-dropdown class="export-report__dropdown" :vs-trigger-click="true" v-if="!isModal">
        Exportar
        <vs-icon class="vsIcon"  icon="expand_more"></vs-icon>
        <vs-dropdown-menu>
          <vs-dropdown-item>
            <div class="xls">
              <img
                @click="exportToXls"
                src="@/assets/images/icons/file_format_xls.png"
                height="42"
                width="42"
                alt="xls"
              />
            </div>
          </vs-dropdown-item>
          <vs-dropdown-item>
            <div class="csv">
              <img
                @click="exportToCsv"
                src="@/assets/images/icons/file_format_csv.png"
                height="42"
                width="42"
                alt="csv"
              />
            </div>
          </vs-dropdown-item>
          <vs-dropdown-item v-if="exportOfx">
            <img
              @click="exportToOfx"
              src="@/assets/images/icons/file_format_ofx.png"
              height="42"
              width="50"
              alt="ofx"
            />
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <div class="dropdown" ref="dropdownMenu" v-else>
        <vs-button
          color="warning"
          type="border"
          class="btnx dropdown__menu"
          icon="expand_more"
          icon-after
          @click="visible = !visible"
          >Exportar</vs-button
        >
        <div class="dropdown-content" v-if="visible">
          <vs-dropdown-item>
            <img
              @click="exportToXls"
              src="@/assets/images/icons/file_format_xls.png"
              height="42"
              width="42"
              alt="xls"
            />
          </vs-dropdown-item>
          <vs-dropdown-item>
            <img
              @click="exportToCsv"
              src="@/assets/images/icons/file_format_csv.png"
              height="42"
              width="42"
              alt="csv"
            />
          </vs-dropdown-item>
          <vs-dropdown-item v-if="exportOfx">
            <img
              @click="exportToOfx"
              src="@/assets/images/icons/file_format_ofx.png"
              height="42"
              width="50"
              alt="ofx"
            />
          </vs-dropdown-item>
        </div>
      </div>
    </div>
    <div v-else>
      <vs-col
        class="con-color"
        vs-type="grid"
        vs-justify="flex-end"
        vs-align="flex-end"
      >
        <v-progress-circular
          :size="36"
          :width="4"
          indeterminate
          :style="{ color: 'rgb(229,107,31)', justifySelf: 'center' }"
        />
        <span class="text-color-primary">{{ reportDownloadMsg }}</span>
      </vs-col>
    </div>

    <b-modal
      title=""
      v-model="showPassword"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      size="xs"
    >
      <vs-row vs-justify="center">
        <vs-col vs-w="12">
          <check-icon />
        </vs-col>
        <h3>Arquivo Gerado</h3>
        <p>Utilize a seguinte <b> senha </b> para extrair o arquivo:</p>
      </vs-row>
      <vs-row vs-type="flex" style="direction: rtl" class="mb-1">
        <vs-col vs-w="12">
          <textarea
            disabled
            class="text-area"
            readonly
            v-model="passwordPhrase"
          />
        </vs-col>
        <vs-col vs-w="2" style="position: absolute">
          <vs-button
            color="warning"
            type="border"
            icon="content_copy"
            icon-after
            style="top: 0.15rem"
            @click="copyPassword"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="center">
        <vs-button class="btn-ok" icon-after @click="showPassword = false"
          >OK</vs-button
        >
      </vs-row>
    </b-modal>
  </div>
</template>

<script>
import mixins from "@/mixins/mixins.js";

export default {
  mixins: [mixins],
  data() {
    return {
      loadingReport: false,
      visible: false,
      showPassword: false,
      passwordPhrase: "",
      report: {
        password: "",
        name: "",
        department: "",
      },
      reportDownloadMsg: "Gerando relatório ...",
    };
  },
  props: {
    search: {
      type: String,
      required: true,
    },
    reportDTO: {
      type: Object,
      required: false,
    },
    isReportDTO: {
      type: Boolean,
      required: false,
      default: false,
    },
    source: {
      type: String,
      required: true,
    },
    reportName: {
      type: String,
      required: true,
    },
    department: {
      type: String,
      required: true,
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: String,
      required: false,
    },
    exportOfx: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportStyle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },

  methods: {
    exportToXls() {
      this.generatePassword();
      this.getXlsxReport();
    },

    exportToCsv() {
      this.generatePassword();
      this.getCsvReport();
    },

    exportToOfx() {
      this.generatePassword();
      this.getOfxReport();
    },

    documentClick(e) {
      const vm = this;
      if (vm.isModal) {
        let el = this.$refs.dropdownMenu;
        let target = e.target;
        if (el !== target && !el.contains(target)) {
          vm.visible = false;
        }
      }
    },

    generatePassword() {
      var length = 10,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.report = {
        password: retVal,
        name: this.reportName,
        department: this.department,
        source: this.source,
      };
    },

    getXlsxReport() {
      const vm = this;
      vm.loadingReport = true;
      vm.reportDownloadMsg = "Gerando relatório ...";
      var bearer = vm.$session.get("bearer");

      const options = vm.getUrlDefinitions();

      if (!this.testNullUndefinedEmpty(this.reportDTO) && vm.isReportDTO) {
        this.reportDTO.password = this.report.password;
        this.reportDTO.name = this.report.name;
        this.reportDTO.department = this.report.department;
        this.reportDTO.source = this.report.source;
      }

      vm.axios
        .post(
          vm.$store.state.filooServer +
            "admin/generate-report-file-xlsx?" +
            options,
          this.testNullUndefinedEmpty(this.reportDTO) && !vm.isReportDTO
            ? this.report
            : this.reportDTO,
          {
            headers: { Authorization: bearer },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          vm.loadingReport = false;
          vm.createDownload(response, "_xlsx");
          vm.showPasswordMessage();
        })
        .catch(() => {
          vm.reportDownloadMsg = "Erro ao gerar relatório";
          setTimeout(function () {
            vm.loadingReport = false;
          }, 8000);
        });
    },

    getCsvReport() {
      const vm = this;
      vm.loadingReport = true;
      vm.reportDownloadMsg = "Gerando relatório ...";
      var bearer = vm.$session.get("bearer");

      const options = vm.getUrlDefinitions();

      if (!this.testNullUndefinedEmpty(this.reportDTO) && vm.isReportDTO) {
        this.reportDTO.password = this.report.password;
        this.reportDTO.name = this.report.name;
        this.reportDTO.department = this.report.department;
        this.reportDTO.source = this.report.source;
      }

      vm.axios
        .post(
          vm.$store.state.filooServer +
            "admin/generate-report-file-csv?" +
            options,
          this.testNullUndefinedEmpty(this.reportDTO) && !vm.isReportDTO
            ? this.report
            : this.reportDTO,
          {
            headers: { Authorization: bearer },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          vm.loadingReport = false;
          vm.createDownload(response, "_csv");
          vm.showPasswordMessage();
        })
        .catch(() => {
          vm.reportDownloadMsg = "Erro ao gerar relatório";
          setTimeout(function () {
            vm.loadingReport = false;
          }, 8000);
        });
    },

    getOfxReport() {
      const vm = this;
      vm.loadingReport = true;
      vm.reportDownloadMsg = "Gerando relatório ...";
      var bearer = vm.$session.get("bearer");

      const options = vm.getUrlDefinitions();

      if (!this.testNullUndefinedEmpty(this.reportDTO) && vm.isReportDTO) {
        this.reportDTO.password = this.report.password;
        this.reportDTO.name = this.report.name;
        this.reportDTO.department = this.report.department;
        this.reportDTO.source = this.report.source;
      }

      vm.axios
        .post(
          vm.$store.state.filooServer +
            "admin/generate-report-file-ofx?" +
            options,
          this.testNullUndefinedEmpty(this.reportDTO) && !vm.isReportDTO
            ? this.report
            : this.reportDTO,
          {
            headers: { Authorization: bearer },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          vm.loadingReport = false;
          vm.createDownload(response, "_ofx");
          vm.showPasswordMessage();
        })
        .catch(() => {
          vm.reportDownloadMsg = "Erro ao gerar relatório";
          setTimeout(function () {
            vm.loadingReport = false;
          }, 8000);
        });
    },

    createDownload(response, type) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.reportName + type + ".zip");
      document.body.appendChild(link);
      link.click();
    },

    showPasswordMessage() {
      const vm = this;
      vm.passwordPhrase =
        vm.$session.get("name").split(" ")[0] +
        "-" +
        vm.report.department +
        "-" +
        vm.report.password;
      vm.showPassword = true;
    },
    copyPassword() {
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        (!this.testNullUndefinedEmpty(event.originalEvent) &&
          event.originalEvent.clipboardData) ||
        navigator.clipboard;

      clipboardData.writeText(this.passwordPhrase);
    },
    getUrlDefinitions() {
      const vm = this;
      var optional = "";
      var search = "";

      if (!vm.testNullUndefinedEmpty(vm.optional)) {
        optional = vm.testNullUndefinedEmpty(vm.search)
          ? "optional=" + vm.optional
          : "&optional=" + vm.optional;
      }

      search = vm.testNullUndefinedEmpty(vm.search) ? "" : vm.search;

      return search + optional;
    },
  },
};
</script>
<style lang="scss" scoped>
.xls {
  margin-left: 2px;
}
.csv {
  margin-left: 5px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  background-color: #f9f9f9;
  min-width: 70px;
  margin-left: 45px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 5px 16px 2px 6px;
}
.text-area {
  width: 100%;
  resize: none;
  border: 0 !important;
  padding: 1rem 0 0 0;
  text-align: center;
  font-weight: bold;
  line-height: 1rem;
}
.btn-ok {
  border: 0;
  border-radius: 0.25em;
  background: initial;
  background-color: orange;
  color: #fff;
  font-size: 1.0625em;
}
.vs-con-dropdown{
  &.parent-dropdown{
    border: 1px solid orange;
    color: orange;
    height: 50px;
    padding: 0 18px;
    border-radius: 0.55rem;
    display: block;
    align-items: center;
    width: 155px;
    .vsIcon{
      margin-left: 16px;
    }
  }
} 
</style>
